import { parseAccountsForFeature } from '@/assets/scripts/parsers/accounts'

/** returns Products - List of available products
@return { Array }
*/
export const getAvailableProducts = state => {
    return state.availableProducts
}

/** returns Accounts Balances
@return { Array }
*/
export const getAccountsBalances = state => parseAccountsForFeature(state.accountsBalances)

/** returns Product Interest Rates
@return { Array }
*/
export const getProductInterestRates = state => {
    return state.productInterestRates.map((interestRate, index) => {
        return { ...interestRate, id: (index + 1) }
    })
}

/** returns Product Plafond
@return { Array }
*/
export const getProductPlafond = state => state.productPlafond
